const CheckpointDocumentsMapper = {
  toTableData: document => ({
    id: document.Id,
    documentType: document.DocumentType,
    fileName: document.FileName,
    reviewStatus: document.CheckpointReappraisalRationaleReview?.Status
  }),
  documentToApolloInput: document => ({
    Id: document.id,
    DocumentType: document.documentType,
    FileName: document.fileName
  })
};

export default CheckpointDocumentsMapper;
